import { useSendLogoutMutation } from "./authApiSlice"
import { useDispatch } from "react-redux"
import { showSpinner, hideSpinner } from "../../components/componentSlice"
import { useNavigate } from "react-router-dom"
import { useEffect } from "react"
import { RESET_STATE } from "../../app/reducers"

const Logout = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [sendLogout, { isLoading }] = useSendLogoutMutation()

    useEffect(() => {
        if (isLoading) {
            dispatch(showSpinner())
        } else {
            dispatch(hideSpinner())
        }
    }, [isLoading, dispatch])

    useEffect(() => {
        const logout = async () => {
            try {
                // First clear the cookies on the backend
                await sendLogout().unwrap()

            } catch (err) {
                console.log("Logout request failed:", err)

            } finally {
                // Clear Redux regardless
                dispatch({ type: RESET_STATE })

                // Go to /
                navigate("/", { replace: true })
            }
        }

        logout()
    }, [sendLogout, dispatch, navigate])

    return null
}

export default Logout